<template>
  <div class="home-container">
    <div class="header">
      <img class="logo-img" src="https://tx-res.supercarrier8.com/sup8-ui/2.0/sup8-h5-app-amison/logo.png" />
    </div>
    <div class="layout">
        <div class="title">
            <div style="margin-right: 8px">Verify Your </div>
            <div>AMAZINGTHING Product</div>
        </div>
        <div>Enter your 16-digit serial number below to confirm authenticity</div>
        <img class="label-img" src="https://tx-res.supercarrier8.com/sup8-ui/2.0/sup8-h5-app-amison/verifyLabel.png" />
        <div class="input-body">
            <div style="margin-bottom: 10px">
              <div class="input-item"  :class="{ 'error': serialNumberError }">
                  <input
                      type="text"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      v-model="formattedSerialNumber"
                      placeholder="Enter your 16-digit serial number"
                      :class="{ 'error': serialNumberError }"
                      maxlength="19" 
                      @input="onSerialNumberInput"
                      @keydown="onSerialNumberKeydown"
                  />
              </div>
              <div class="input-error" v-if="serialNumberError">Enter your 16-digit serinal number</div>
              <div class="input-desc" @click.stop="JumpTo('help')">Can’t Find the Verify Code? Need support?</div>
              
            </div>
            <div style="margin-bottom: 10px">
              <div class="input-item" :class="{ 'error': userNameError }">
                  <input type="text" v-model="fromInfo.userName" placeholder="Name"  :class="{ 'error': userNameError }" />
              </div>
              <div class="input-error" v-if="userNameError">Please enter a username with fewer than 64 characters</div>
            </div>
            <div style="margin-bottom: 10px">
              <div class="input-item" :class="{ 'error': emailError }">
                  <input type="text" v-model="fromInfo.email" placeholder="Email"  :class="{ 'error': emailError }" />
              </div>
              <div class="input-error" v-if="emailError">A valid email address is required</div>
            </div>
            <div class="privacy-policy">
                <van-checkbox v-model="checked" shape="square"  icon-size="16px"></van-checkbox>
                <div style="margin-left: 10px;flex: 1">By Clicking, you agree to <span class="buleColor underline" @click.stop="JumpTo('service')">Terms of Service </span> and <span class="buleColor underline" @click.stop="JumpTo('policy')">Privacy Policy</span>. </div>
            </div>
        </div>
    <div class="remark">
        <div class="margin-b">If your package does not have a security label, or the label differs from our reference example, this does not necessarily indicate a counterfeit product. Please note that security codes are only applied to products distributed through offline retail channels.</div>
        <div class="margin-b flex">
            <div>AMZINGTHING guarantees the authenticity of all products purchased through our Authorized Retailers, Authorized Distributors, and Official Online Channels.Security Code Coverage</div> 
            
        </div>
        <div class="margin-b">Our security code system applies to products sold in the following countries and regions:</div>

        <ul style="list-style: disc;margin-left: 20px">
            <li>Asia: Hong Kong, Taiwan, Macau, Vietnam, Indonesia, Singapore, Philippines, Thailand, Malaysia, India</li>
            <li>Middle East: United Arab Emirates (UAE), Kuwait, Iran, Israel, Qatar, Bahrain, Iraq, Saudi Arabia (KSA)</li>
            <li>Europe: France, United Kingdom, Germany, Italy, Turkey, Norway, Switzerland</li>
            <li>North America: United States of America (USA)</li>
        </ul>

    </div>
    <div class="verify-btn" :class="{ actived: isFormValid && isSubmit }" @click.stop="onVerify">Verify Now</div>
    </div>
  </div>
</template>
  
  <script>
import api from "@/api";
import { mapGetters } from "vuex";
import storage from "../utils/storage";
let getters = {
  code: "code",
  lang: "lang",
  platform: "platform",
  channelType: "channelType",
  eNo: "eNo",
  gis: "gis",
  gpsType: "gpsType",
  childData: "childData",
  needGis: "needGis", // 当前模板是否需要获取地理位置
};
export default {
  name: "Home",
   components: {
  },
  data() {
    return {
      checked: false,
      fromInfo: {
        serialNumber: "",
        userName:"",
        email: ""
      },
      serialNumberError: false,
      userNameError: false,
      emailError: false,
      isSubmit: true
    };
  },
   computed: {
    ...mapGetters(getters),
    formattedSerialNumber: {
      get() {
        // Format the raw serial number with hyphens
        const raw = this.fromInfo.serialNumber.replace(/\D/g, ''); // Remove non-digits
        let formatted = '';
        for (let i = 0; i < raw.length; i++) {
          if (i > 0 && i % 4 === 0) {
            formatted += '-';
          }
          formatted += raw[i];
        }
        return formatted;
      },
      set(value) {
        // Update the raw serial number when user types
        this.fromInfo.serialNumber = value.replace(/\D/g, ''); // Only keep digits
      }
    },
    isFormValid() {
      // Check if all fields are filled and checkbox is checked
      return (
        !this.emailError &&
        !this.serialNumberError &&
        !this.userNameError
      );
    }
  },
  watch: {
     'fromInfo.serialNumber'(val) {
      if(!val.trim() || !/^\d{16}$/.test(val)) {
        this.serialNumberError = true;
      } else {
        this.serialNumberError = false;
      }
    },
    'fromInfo.userName'(val) {
      // When user name changes, reset isSubmit to true
      if (!val.trim() || val.trim().length > 64) {
        this.userNameError = true;
      } else {
        this.userNameError = false;
      }
    },
    'fromInfo.email'(val) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!val.trim() || !emailRegex.test(val.trim())) {
        this.emailError = true;
      } else {
        this.emailError = false;
      }
    },
    num: {
      handler(value) {
        if (value === 2) {
          console.log("执行吧", this.eventId);
          console.log("locationChannel", this.locationChannel);
          console.log("eventId", this.eventId);
          this.getAntiInfo();
        }
      },
      deep: true
    }
  },
  async created(options) {
    let userInfo = storage.getStorage("userInfo");
    if(userInfo) {
      userInfo = JSON.parse(userInfo)
      this.fromInfo.userName = userInfo.userName
      this.fromInfo.email = userInfo.email
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromRoute = from;
      // this.fromPath = from.path
      console.log("来自页面:", this, from.path);
    });
  },

  methods: {
     onSerialNumberInput(event) {
      const input = event.target.value;
      // Only allow digits and hyphens, remove any other characters
      const digitsOnly = input.replace(/[^0-9-]/g, '');
      // Remove existing hyphens and reformat
      const rawDigits = digitsOnly.replace(/-/g, '');
      // Limit to 16 digits max
      if (rawDigits.length <= 16) {
        this.fromInfo.serialNumber = rawDigits;
      }
    },
    
    // Handle keydown to prevent non-numeric input
    onSerialNumberKeydown(event) {
      // Allow backspace, delete, tab, escape, enter, and arrow keys
      if ([46, 8, 9, 27, 13, 110, 190].indexOf(event.keyCode) !== -1 ||
          // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
          (event.keyCode === 65 && event.ctrlKey === true) ||
          (event.keyCode === 67 && event.ctrlKey === true) ||
          (event.keyCode === 86 && event.ctrlKey === true) ||
          (event.keyCode === 88 && event.ctrlKey === true) ||
          // Allow arrow keys
          (event.keyCode >= 35 && event.keyCode <= 39)) {
        return;
      }
      // Ensure that it is a number and stop the keypress
      if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && 
          (event.keyCode < 96 || event.keyCode > 105)) {
        event.preventDefault();
      }
    },
    JumpTo(status) {
        if(status === 'service') {
            window.location.href = "https://www.amazingthing.com/policies/terms-of-service"
        } else if(status === 'policy') {
            window.location.href = "https://www.amazingthing.com/policies/privacy-policy"
        } else if(status === 'help') {
            window.location.href = "https://www.amazingthing.com/pages/contact"
        }
    },
    onVerify() {
        if(!this.isFormValid || !this.isSubmit) {
            return
        }
         // Reset error states
        this.serialNumberError = false;
        this.userNameError = false;
        this.emailError = false;
        
        // Validate inputs
        let isValid = true;
        
        if (!this.fromInfo.serialNumber.trim() || !/^\d{16}$/.test(this.fromInfo.serialNumber)) {
            this.serialNumberError = true;
            isValid = false;
            this.isSubmit = false
        }
        
        if (!this.fromInfo.userName.trim() || this.fromInfo.userName.trim().length > 64) {
            this.userNameError = true;
            isValid = false;
            this.isSubmit = false
        }
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!this.fromInfo.email.trim() || !emailRegex.test(this.fromInfo.email.trim())) {
            this.emailError = true;
            isValid = false;
            this.isSubmit = false
        }
        setTimeout(()=> {
        this.isSubmit = true
        },3000)
        if (!this.checked) {
           this.$toast("Please read and check the Privacy Policy");
           isValid = false;
        }
        
        // If validation fails, do not proceed
        if (!isValid) {
            return;
        }
        
        // Continue with verification logic if all fields are filled
        console.log("Validation passed, proceeding with verification...")
        this.queryDigit(this.fromInfo.serialNumber)

    },
    async queryDigit(code) {
        this.isSubmit = false
        storage.setStorage("userInfo", JSON.stringify({userName: this.fromInfo.userName, email: this.fromInfo.email}));
      const res = await api.queryDigit({digit: code})
      if(res.code === 200) {
        this.$router.push({
            path: "/result",
            query: {
            code: code,
            userName: this.fromInfo.userName,
            email: this.fromInfo.email
            },
        });
      } else {
         this.$toast(this.$t(res.code))
      }
      setTimeout(()=> {
        this.isSubmit = true
        },3000)
      
    },
    
  },
};
</script>
<style scoped>


</style>
  <style  lang="scss">
  .van-toast__text {
    white-space: pre-line !important; /* 覆盖默认的nowrap */
    word-break: break-all !important;
    text-align: center !important;
  }
.home-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  box-sizing: border-box;

  .layout {
    width: 100%; // Full width on smaller screens
    padding:22px;
    box-sizing: border-box;
    
    // When screen width exceeds 960px
    @media (min-width: 800px) {
        max-width: 760px; // Fixed width for larger screens
        margin: 0 auto; // Center the layout
        padding:30px;
    }
  }
  .header {
    height: 100px;
    background: #000;
    padding-left: 25px;
    padding-top: 40px;
    box-sizing: border-box;
     @media (min-width: 800px) {
        padding-top: 35px;
    }
    .logo-img {
      width: 191px;
      height: auto;
      @media (min-width: 660px) {
          width: 230px;
      }
    }
  }
  .label-img {
    width: 80%;
    margin: 40px auto 20px;
    display: block;
    @media (min-width: 660px) {
        width: 50%;
    }
  }
  .title {
    font-size: 27px;
    font-weight: bold;
    margin-bottom: 10px;
    @media (min-width: 660px) {
        display: flex;
        font-size: 36px;
    }
  }
  .input-body {
    .input-desc {
        color: #3992FF;
        font-size: 12px;
        margin-bottom: 10px;
        display: inline-block;
        cursor: pointer;
    }
    .input-item {
        width: 100%;
        height: 58px;
        font-size: 13px;
        background: #F8F8F8;
        border-radius: 8px;
        padding: 10px 20px;
        box-sizing: border-box;
        margin-bottom: 5px;
        border: 1px solid #F8F8F8;
        // &:first-child {
        //     margin-bottom: 5px;
        // }
        &.error {
            border-color: red;
            color: red;
        }
        
        input {
            border: none;
            width: 100%;
            height: 100%;
            background: #F8F8F8;
            &.error::placeholder {
                color: red;
            }
        }
    }
    .input-error {
      color: red;
      font-size: 12px
    }
    .privacy-policy {
        width: 110%;
        display: flex;
        font-size: 12px;
        transform: scale(0.833);
        align-items: center;
        margin: 10px 0 20px -6%;
        color: #6F6F6F;
        @media (min-width: 660px) {
            transform: scale(1);
            width: 100%;
            margin: 10px 0 10px 5px;
        }
    }
    .underline {
      text-decoration: underline;
      cursor: pointer;
    }
    .buleColor {
        color: #3992FF;
    }
  }
  .remark {
    font-size: 12px;
    margin-top: 30px;
    line-height: 1.5;
    // @media (min-width: 660px) {
    //     margin-top: 30px;
    // }
    .margin-b {
        margin-bottom: 18px;
        
    }
    .flex {
        // @media (max-width: 660px) {
        //     display: flex;
        // }
    }
  }
  .verify-btn {
    width: 198px;
    height: 46px;
    line-height: 46px;
    border-radius: 23px;
    text-align: center;
    background: #ccc;
    margin: 40px auto 0;
    &.actived {
        background: #000;
        color: #fff;
    }
  }
}
</style>
  